<template>
  <v-row align="center" justify="center" class="h-100">
    <AppLoader />
  </v-row>
</template>

<script>
import * as Sentry from '@sentry/vue'

import AppLoader from '@/common/AppLoader.vue'
import { IMANAGE_REFUSAL_USER_SETTINGS_KEY } from '@/common/imanage/IManageAuthDialog.vue'
import { AUTH_DATA_COOKIE_KEY, getSignInRoute } from '@/common/utils/login'
import { SUBDOMAIN_COOKIE_KEY, getRootDomainFromUrl } from '@/common/utils/url'
import { USER_ID_STORAGE_KEY, USER_TOKEN_STORAGE_KEY } from '@/common/utils/users'
import { removeUserSetting } from '@/common/utils/userSettings'
import { STORE_PERSIST_KEY } from '@/store'

export default {
  name: 'Logout',
  components: { AppLoader },
  props: {
    isLogOut: {
      type: [Boolean, String],
    },
    isVoluntaryLogOut: {
      type: [Boolean, String],
    },
    // Overrides the basic functionality that redirects to the login
    redirectPath: {
      type: String,
      required: false,
    },
    // Full path of the route we want to come back to
    returnRoute: {
      type: String,
      default: '',
    },
  },
  created () {
    const clientAppUrl = import.meta.env.VUE_APP_CLIENT_URL
    const cookieDomain = getRootDomainFromUrl(clientAppUrl)
    const subdomain = this.$cookies.get(SUBDOMAIN_COOKIE_KEY)
    const userId = localStorage.getItem(USER_ID_STORAGE_KEY);

    this.$cookies.remove(AUTH_DATA_COOKIE_KEY, null, cookieDomain)
    this.$cookies.remove(SUBDOMAIN_COOKIE_KEY, null, cookieDomain)

    if (this.isVoluntaryLogOut) {
      removeUserSetting(userId, IMANAGE_REFUSAL_USER_SETTINGS_KEY);
    }
    
    localStorage.removeItem(USER_TOKEN_STORAGE_KEY)
    localStorage.removeItem(USER_ID_STORAGE_KEY)
    try {
      if (window.zE) {
        window.zE('messenger', 'logoutUser')
      }
    } catch {
      console.error('zendesk log out failed')
    }
    try {
      Sentry.setUser(null)
    } catch {
      console.error('Could not unset Sentry user ID')
    }
    // Done in an immediately queued timer so that the persist already handled the changes it needed to do
    // And we can then remove it entirely
    setTimeout(() => {
      localStorage.removeItem(STORE_PERSIST_KEY)
      let host = window.location.host
      // If we logged from a subdomain, replace the first part of the host (the subdomain part)
      // With the subdomain so that we're back where we started
      if (subdomain) {
        host = host.replace(host.split('.')[0], subdomain)
      }
      const ROUTE_PATH_PREPEND_URL = window.location.protocol + '//' + host

      if (this.redirectPath) {
        window.location.replace(
          ROUTE_PATH_PREPEND_URL +
          this.redirectPath,
        )
        return
      }

      // Force refresh into sign in. Every state is reset.
      // Forward query params
      const queryParamsToForward = {
        isLogOut: this.isLogOut,
        isVoluntaryLogOut: this.isVoluntaryLogOut,
      }

      if (this.returnRoute) {
        queryParamsToForward.returnRoute = this.returnRoute || '/'
      }

      window.location.replace(
        ROUTE_PATH_PREPEND_URL +
        this.$router.resolve(getSignInRoute({}, queryParamsToForward)).href,
      )
    }, 0)
  },
}
</script>
